__turbopack_context__.v({
  "body": "button-module__HjQxJG__body",
  "bodySpinner": "button-module__HjQxJG__bodySpinner",
  "button": "button-module__HjQxJG__button",
  "destructive": "button-module__HjQxJG__destructive",
  "destructiveSoft": "button-module__HjQxJG__destructiveSoft",
  "fullWidth": "button-module__HjQxJG__fullWidth",
  "ghost": "button-module__HjQxJG__ghost",
  "iconOnly": "button-module__HjQxJG__iconOnly",
  "label": "button-module__HjQxJG__label",
  "labelledLoading": "button-module__HjQxJG__labelledLoading",
  "lg": "button-module__HjQxJG__lg",
  "loading": "button-module__HjQxJG__loading",
  "md": "button-module__HjQxJG__md",
  "primary": "button-module__HjQxJG__primary",
  "secondary": "button-module__HjQxJG__secondary",
  "sm": "button-module__HjQxJG__sm",
  "spin": "button-module__HjQxJG__spin",
  "spinner": "button-module__HjQxJG__spinner",
  "xl": "button-module__HjQxJG__xl",
});
